import { combineReducers } from "@reduxjs/toolkit";
import coinFromValueSlice from "./coinFromValueSlice";
import coinSelectSlice from "./coinSelectSlice";
import selectedExchangeSlice from "./selectedExchangeSlice";
import exchangeResSlice from "./exchangeResSlice";
import toastSlice from "./toastSlice";
import walletAddressSlice from "./walletAddress";
import historySlice from "./historySlice";
import netIconSlice from "./netIconSlice";
import netMemoSlice from "./netMemoSlice";
import extraIdSlice from "./extraIdSlice";

const rootReducer = combineReducers({
  toast: toastSlice,
  coinSelect: coinSelectSlice,
  coinFromValue: coinFromValueSlice,
  selectedExchange: selectedExchangeSlice,
  exchangeRes: exchangeResSlice,
  walletAddress: walletAddressSlice,
  history: historySlice,
  netIcon: netIconSlice,
  netMemo: netMemoSlice,
  extraId: extraIdSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
